var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoteTemplateColoured(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8125 32.0625H14.25V35.625H17.8125V32.0625ZM53.4375 0H3.5625C1.60312 0 0 1.60312 0 3.5625V49.875C0 51.8344 1.60312 53.4375 3.5625 53.4375H14.25V57L21.375 53.4375L28.5 57V53.4375H53.4375C55.3969 53.4375 57 51.8344 57 49.875V3.5625C57 1.60312 55.3969 0 53.4375 0ZM14.25 46.3125H7.125V42.75H14.25V46.3125ZM49.875 46.3125H28.5V42.75H49.875V46.3125ZM49.875 39.1875H10.6875V7.125H49.875V39.1875ZM17.8125 10.6875H14.25V14.25H17.8125V10.6875ZM17.8125 24.9375H14.25V28.5H17.8125V24.9375ZM17.8125 17.8125H14.25V21.375H17.8125V17.8125Z",
    fill: "url(#paint0_linear_3790_14999)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3790_14999",
    x1: 13.0502,
    y1: 44.9725,
    x2: 44.4264,
    y2: 7.05963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0ADEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576485,
    stopColor: "#15C244"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9F025"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteTemplateColoured);
export default __webpack_public_path__ + "static/media/noteTemplateColoured.d470d6db79add106cf5402c98e55cb1a.svg";
export { ForwardRef as ReactComponent };